const lower = extension => extension.toLowerCase()

const getMixedFileType = extension => {
  if (lower(extension) === 'jpg' || lower(extension) === 'jpeg') {
    return 'jpg'
  }

  if (lower(extension) === 'tif' || lower(extension) === 'tiff') {
    return 'tiff'
  }

  return extension
}

export default getMixedFileType



// WEBPACK FOOTER //
// ./src/utils/getMixedFileType.js